import { API as e, Resource as t } from "@coveo/platform-client";
//#region src/resources/HostedPagesInternalResource.ts
var n = class n extends t {
	static {
		this.baseUrl = `/rest/organizations/${e.orgPlaceholder}/hostedpages`;
	}
	listHostedPagesByProjectId(e, t = {}) {
		return this.api.get(this.buildPath(`${n.baseUrl}/projects/pages`, {
			...t,
			projectId: e
		}));
	}
};
//#endregion
export { n as HostedPagesInternalResource };

//# sourceMappingURL=HostedPagesInternalResource.js.map